export const environment = {
    apiUrl: '',
    kbapi_vi: 'https://app.stage.studentsuccess.anthology.com/api/v1/',
    i18n: 'i18n/all?local=en_US',
    production: false,
    auth0: {
        domain: 'stdntsuccess-stage.us.auth0.com',
        clientId: 'tNwIad4bzrwXDtZ7pz6mpeXU1OroSVuQ'
    },
    environment: 'stage'
};
